import http from "@/helper/http";
import {BaseVO} from "@/model/global";
import {useMutation} from "@tanstack/react-query";
import {AxiosProgressEvent} from "axios";

export enum CommonEnum {
}

export interface DeletesBO {
    url: string;
    ids: number[];
}

export interface SearchBO {
    keyword: string;
}

export interface UploadFileBO {
    formData: FormData
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void
}

export interface UploadFileVO {
    id?: number;
    targetId?: number;
    name: string;
    size?: number;
    tag?: number;
    type?: string;
    url: string;
    key?: string;
    rate?: number;
    tempId?: string
}

export const useUploadFile = () => useMutation({
    mutationFn: ({formData, onUploadProgress}: UploadFileBO) => http.post<BaseVO<UploadFileVO>>({
        url: "/file/uploadFile",
        headers: {
            "Content-Type": "multipart/form-data",
        }, onUploadProgress: event => {
            onUploadProgress(event)
        }, data: formData
    })
})

export const useCallDeletes = () => useMutation({
    mutationFn: (data: DeletesBO) =>
        http.delete<BaseVO<null>>({url: data.url, data: {ids: data.ids}})
})
